import { MonitorParameter } from '@/global/interface/monitor-object/monitor-parameter'
import './index.less'
import { useEffect, useRef, useState } from 'react';
import { MONITORING_DATA_TYPE } from '@/enums/monitoring-data-type';
import { queryInfluxCurrentDataList } from '@/api/influx/influx';
import { TimeValue } from '@/global/interface/time-value';
import classNames from 'classnames';
import { Transfer2DisplayScale } from '@/global/utils/unit-type';
import { InlineMath } from 'react-katex';

interface Iprops {
    monitorParameters: MonitorParameter[]
}

export default function MonitorParameterCurrentPanel(props: Iprops) {
    const { monitorParameters } = props;

    const [paramDataList, setParamDataList] = useState<MonitorParameter[]>([]); // 含当前值的参数
    const intervalRef = useRef<NodeJS.Timeout>(null); // 定时器

    useEffect(() => {
        return () => {
            clearIntervalRef();
        };
    }, [])

    useEffect(() => {
        if (!monitorParameters) return;
        getCurrentData();
        clearIntervalRef();
        startInterval();
    }, [monitorParameters])

    // 清除定时器
    const clearIntervalRef = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    // 开启定时器
    const startInterval = () => {
        if (intervalRef.current) return;
        intervalRef.current = setInterval(() => {
            getCurrentData();
        }, 5000);
    };

    // 获取当前值
    const getCurrentData = () => {
        let datas = monitorParameters.map(item => {
            return {
                metric: item.symbol,
                type: MONITORING_DATA_TYPE.MONITOR_OBJ,
                id: item.id,
            }
        });
        queryInfluxCurrentDataList(datas).then(res => {
            let list: TimeValue[] = res.data || [];
            list.forEach(item => {
                let param = monitorParameters.find(p => p.id == item.id);
                if (param) {
                    // 转成显示单位下的数值
                    let scale = Transfer2DisplayScale(param.unit);
                    param.currentValue = item.value * scale;
                }
            })
            setParamDataList([...monitorParameters]);
        })
    }

    return (
        <div className="monitor-object-param-current-panel">
            {paramDataList.map((item, index) => (
                <div className={classNames({
                    "item": true,
                    "even": (index + 1) % 2 == 0
                })}>
                    <div className="divider"></div>
                    <div className="label">
                        {item.encoding}{item.name}
                    </div>
                    <div className="current-value ellipsis">
                        <div className="value">{item.currentValue?.toFixed(0)}</div>
                        <div className="unit">
                            {<InlineMath math={item.unit} /> || ''}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}